var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tabs',{attrs:{"type":"border-card"}},[_c('el-tab-pane',{attrs:{"label":_vm.code ? '税务托运人信息详情' : '添加税务托运人信息'}},[_c('compAdd')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }